import Container from "../../layouts/containers/container";
import List from "../list";

export default function Stats({ 
    center = false,
    value, 
    title,
    titleSize = '14px',
    titleColor = '#000000',
    valueSize = '40px',
    valueColor = '#1577EA', 
}) {
    return (
        <List gap="10px" style={{
            alignItems: center ? 'center' : 'unset'
        }}>
            <Container.Text fontSize={valueSize} color={valueColor}>{ value }</Container.Text>
            <Container.Text fontSize={titleSize} color={titleColor}>{ title }</Container.Text>
        </List>
    )
}
